export default "__VITE_ASSET__BqgrkdIh__"